import {
  CHEERS_UP_BLUR_URL,
  CHEERS_UP_DISCORD_URL,
  CHEERS_UP_ELEMENT_URL,
  CHEERS_UP_LOOKSRARE_URL,
  CHEERS_UP_OPENSEA_COLLECTION_NAME,
  CHEERS_UP_PERIOD_BLUR_URL,
  CHEERS_UP_PERIOD_ELEMENT_URL,
  CHEERS_UP_PERIOD_LOOKSRARE_URL,
  CHEERS_UP_PERIOD_OPENSEA_URL,
  CHEERS_UP_PERIOD_X2Y2_URL,
  CHEERS_UP_TWITTER_URL,
  CHEERS_UP_X2Y2_URL,
  CRYPTONATTY_TWITTER_URL,
} from "@/constants/index";
import { getNftCollectionUrl } from "@/utils/util";
import classNames from "classnames";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { FAQLink } from "./faq-link";

const FAQsEn = [
  {
    title: <>What is the relationship between Cheers UP and bilibili?</>,
    desc: (
      <>
        Cheers UP is an official IP authorized by bilibili. We originate from
        one of the most representative community cultures of bilibili
        “(゜-゜)つロcheers!”, with our NFT design basing on the bilibili's
        iconic IP “little TV”.
      </>
    ),
  },
  {
    title: <>Where can I buy Cheers UP NFTs?</>,
    desc: (
      <>
        We have already sold out, but you can always buy one from the secondary
        markets, Cheers UP Period NFT is the blindbox of Cheers UP Official NFT.
        <br />
        Cheers UP Official:{" "}
        <FAQLink href={getNftCollectionUrl(CHEERS_UP_OPENSEA_COLLECTION_NAME)}>
          OpenSea
        </FAQLink>
        , <FAQLink href={CHEERS_UP_BLUR_URL}>Blur</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_X2Y2_URL}>X2Y2</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_ELEMENT_URL}>Element</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_LOOKSRARE_URL}>LooksRare</FAQLink>, etc.
        <br />
        Cheers UP Period:{" "}
        <FAQLink href={CHEERS_UP_PERIOD_OPENSEA_URL}>OpenSea</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_PERIOD_BLUR_URL}>Blur</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_PERIOD_X2Y2_URL}>X2Y2</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_PERIOD_ELEMENT_URL}>Element</FAQLink>,{" "}
        <FAQLink href={CHEERS_UP_PERIOD_LOOKSRARE_URL}>LooksRare</FAQLink>, etc.
      </>
    ),
  },
  {
    title: (
      <>
        What is the difference between Cheers UP Period and Cheers UP Official?
      </>
    ),
    desc: (
      <>
        Cheers UP NFTs have two smart contracts: Unrevealed Cheers UP Period and
        Revealed Cheers UP Official. Holders get chances to choose if they want
        to reveal Cheers UP Period or not. By revealing, it will burn a Cheers
        UP Period and mint a random new Cheers UP Official. Cheers UP Official
        will have access to full utilities.
      </>
    ),
  },
  {
    title: <>I just bought Cheers UP NFTs; What should I do next?</>,
    desc: (
      <>
        Welcome to Cheers UP Family! Here is a warm checklist for you to start
        with:
        <br />
        1. Join our <FAQLink href={CHEERS_UP_DISCORD_URL}>Discord</FAQLink>, and
        meet friends!
        <br />
        2. Follow <FAQLink href={CHEERS_UP_TWITTER_URL}>
          @CheersUP_NFT
        </FAQLink>{" "}
        and <FAQLink href={CRYPTONATTY_TWITTER_URL}>@CryptoNatty_io</FAQLink> on
        Twitter to get the latest feeds!
        <br />
        3. Log in to CrytoNatty, connect your wallet, and go to{" "}
        <FAQLink href="/profile">My Profile</FAQLink> to verify as a holder!
        <br />
        4. Let’s <FAQLink href="/collection?tab=brewing">brew</FAQLink> to get
        some CUP Points!
        <br />
        5. Verify on bilibili and be certified as an NFT user! For details refer
        to our <FAQLink href={CHEERS_UP_DISCORD_URL}>Discord</FAQLink>.
        <br />
        6. Explore more features, like{" "}
        <FAQLink href="/meme/land">Meme Generator</FAQLink>,{" "}
        <FAQLink href="/mall">Mall</FAQLink>, and more!
        <br />
        7. Enjoy <FAQLink href="/licence-guide">Commercial License</FAQLink> to
        get more influence!
      </>
    ),
  },
];

const FAQsCn = [
  {
    title: <>Cheers UP和bilibili什么关系？</>,
    desc: (
      <>
        Cheers UP源自“(゜-゜)つロ干杯!”，是bilibili最具有代表性的社区文化之一，
        而NFT设计则是参考bilibili特色的官方IP“小电视”。
      </>
    ),
  },
  {
    title: <>如何购买Cheers UP NFT?</>,
    desc: (
      <>
        目前全部5000个NFT已经售罄，可以前往NFT二级交易市场购买，Cheers UP Period
        NFT 是 Cheers UP Official NFT的盲盒。
        <br />
        Cheers UP Official：
        <FAQLink href={getNftCollectionUrl(CHEERS_UP_OPENSEA_COLLECTION_NAME)}>
          OpenSea
        </FAQLink>
        , <FAQLink href={CHEERS_UP_BLUR_URL}>Blur</FAQLink>，
        <FAQLink href={CHEERS_UP_X2Y2_URL}>X2Y2</FAQLink>，
        <FAQLink href={CHEERS_UP_ELEMENT_URL}>Element</FAQLink>，
        <FAQLink href={CHEERS_UP_LOOKSRARE_URL}>LooksRare</FAQLink> 等。
        <br />
        Cheers UP Period：
        <FAQLink href={CHEERS_UP_PERIOD_OPENSEA_URL}>OpenSea</FAQLink>，
        <FAQLink href={CHEERS_UP_PERIOD_BLUR_URL}>Blur</FAQLink>，
        <FAQLink href={CHEERS_UP_PERIOD_X2Y2_URL}>X2Y2</FAQLink>，
        <FAQLink href={CHEERS_UP_PERIOD_ELEMENT_URL}>Element</FAQLink>，
        <FAQLink href={CHEERS_UP_PERIOD_LOOKSRARE_URL}>LooksRare</FAQLink> 等。
      </>
    ),
  },
  {
    title: <>Cheers UP Period和Cheers UP Official有什么区别？</>,
    desc: (
      <>
        Cheers UP NFT采用双合约制，盲盒态Cheers UP Period以及开图态Cheers UP
        Official，持有者可自行选择是否开图；开图将会销毁一个Cheers UP
        Period并随机铸造一个新的Cheers UP Official；开图后的Cheers UP
        Official享有完全的权益。
      </>
    ),
  },
  {
    title: <>我已经购买了Cheers UP NFT，接下来我应该做什么？</>,
    desc: (
      <>
        恭喜加入Cheers UP大家庭！这里有一份便捷的清单可供参考：
        <br />
        1. 加入<FAQLink href={CHEERS_UP_DISCORD_URL}>Discord</FAQLink>
        社区相遇志同道合的朋友；
        <br />
        2. Twitter关注
        <FAQLink href={CHEERS_UP_TWITTER_URL}>@CheersUP_NFT</FAQLink>和
        <FAQLink href={CRYPTONATTY_TWITTER_URL}>@CryptoNatty_io</FAQLink>
        获取最新消息；
        <br />
        3. 登录CryptoNatty官网，链接钱包，在
        <FAQLink href="/profile">My Profile</FAQLink>里完成持有者验证；
        <br />
        4. 让你的Cheers UP开始酿造 (
        <FAQLink href="/collection?tab=brewing">Brew</FAQLink>) 吧！
        <br />
        5. 获得bilibili紫色钻石认证，
        <FAQLink href={CHEERS_UP_DISCORD_URL}>Discord</FAQLink>
        社区中有详细教程！
        <br />
        6. 体验更多玩法，比如<FAQLink href="/meme/land">Meme生成器</FAQLink>，
        <FAQLink href="/mall">积分商城</FAQLink>等！
        <br />
        7. 享受NFT<FAQLink href="/licence-guide">商业授权</FAQLink>扩大影响力！
      </>
    ),
  },
];

const ExpandButton = ({ expanded, onClick = () => {} }) => {
  return (
    <button
      className="btn-unstyled w-[100px] h-[40px] rounded-full flex items-center justify-center group relative bg-[#395AFF] transition-all group-hover:w-[40px]"
      onClick={onClick}
    >
      <div
        className={classNames(
          "absolute w-[16px] h-[2px] bg-white left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition",
          { "rotate-180": !expanded }
        )}
      ></div>
      <div
        className={classNames(
          "absolute w-[16px] h-[2px] bg-white left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition",
          { "rotate-90": !expanded }
        )}
      ></div>
    </button>
  );
};

const FAQItem = ({ title, desc, expanded, onClick }) => {
  return (
    <div className="border-0 border-t border-solid border-[rgba(255,255,255,.4)] pt-[32px] pb-[40px] text-white">
      <div
        className={classNames(
          "group text-[18px] font-black flex items-center hover:text-[#395AFF] cursor-pointer",
          { "text-[#395AFF]": expanded }
        )}
        onClick={onClick}
      >
        <div className="flex-1 mr-[16px] leading-[28px]">{title}</div>

        <div className="min-w-[100px] w-[100px] flex justify-center">
          <ExpandButton expanded={expanded} />
        </div>
      </div>

      <div className="flex">
        <div
          className={classNames(
            "flex-1 text-[16px] leading-[24px] font-normal transition-all overflow-hidden mr-[16px]",
            expanded ? "h-auto opacity-100 pt-[24px]" : "h-0 opacity-0 pt-0"
          )}
        >
          {desc}
        </div>

        <div className="min-w-[100px] w-[100px]"></div>
      </div>
    </div>
  );
};

export const FAQ = () => {
  const { locale } = useRouter();
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [expand, setExpand] = useState(false);
  const intersectionObserverRef = useRef<IntersectionObserver>();
  const domRef = useRef<HTMLImageElement>();

  const faqs = locale === "cn" ? FAQsCn : FAQsEn;

  const handleExpandClick = (i) => {
    if (expandedKeys.includes(i)) {
      setExpandedKeys(expandedKeys.filter((key) => key != i));
    } else {
      setExpandedKeys([...expandedKeys, i]);
    }
  };

  useEffect(() => {
    intersectionObserverRef.current = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          // console.log("entry", entry);
          setExpand(entry.isIntersecting);

          // if (entry.isIntersecting) {
          //   intersectionObserverRef.current.disconnect();
          // }
        });
      },
      {
        threshold: 0.8,
        rootMargin: "100px 0px 0px 0px",
      }
    );
    intersectionObserverRef.current.observe(domRef.current);
    return () => {
      intersectionObserverRef.current.disconnect();
    };
  }, []);

  return (
    <div className="mt-[180px] container mx-auto 2xl:w-[1440px] flex pb-[160px]">
      <div className="w-[25%] max-w-[300px] mt-[118px] mr-[92px] relative">
        <img
          src="/img/cheersup-v2/faq-1.png"
          className={classNames("w-full align-top transition duration-500", {
            "rotate-[24deg]": expand,
          })}
          alt=""
        />

        <img
          src="/img/cheersup-v2/faq-2.png"
          className={classNames(
            "w-full align-top absolute left-0 top-0 transition duration-500",
            {
              "rotate-[12deg]": expand,
            }
          )}
          alt=""
        />

        <img
          src="/img/cheersup-v2/faq-3.png"
          className="w-full align-top absolute left-0 top-0"
          alt=""
          ref={domRef}
        />
      </div>

      <div className="flex-1">
        <div className="text-[60px] font-DIN_Alternate text-white mb-[80px]">
          FAQS
        </div>

        <div>
          {faqs.map((faq, i) => {
            return (
              <FAQItem
                key={i}
                title={faq.title}
                desc={faq.desc}
                expanded={expandedKeys.includes(i)}
                onClick={() => {
                  handleExpandClick(i);
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
